import React from 'react';
import { UserAvatar } from '@/components/UserAvatar';
import { Crown, Check, Clock } from 'lucide-react';
import { TRIP_SETTINGS } from '@/constants/testIds';

export default function ParticipantList({ participants = [], ownerId, compact = false }) {
    if (!participants.length) return null;
    return (
        <div className={`flex flex-wrap gap-2 ${compact ? '' : 'mt-2'}`}>
            {participants.map((p) => {
                const isOwner = p.user_id === ownerId;
                const submitted = !!p.preferences_submitted;
                return (
                    <div
                        key={p.user_id}
                        className="inline-flex items-center gap-2 pl-1.5 pr-3 py-1 rounded-full border border-[var(--ns-border)] bg-white"
                        title={`${p.name || 'Traveler'}${isOwner ? ' (owner)' : ''} — ${submitted ? 'preferences submitted' : 'waiting for preferences'}`}
                    >
                        <div className="relative">
                            <UserAvatar name={p.name} picture={p.picture} size={26} />
                            {isOwner && (
                                <span
                                    data-testid={TRIP_SETTINGS.ownerCrown}
                                    className="absolute -top-1 -right-1 w-4 h-4 rounded-full flex items-center justify-center shadow"
                                    style={{ background: 'var(--ns-clay)' }}
                                >
                                    <Crown size={9} className="text-white" />
                                </span>
                            )}
                        </div>
                        <span className="text-xs font-medium text-[var(--ns-text)] max-w-[120px] truncate">{p.name || 'Traveler'}</span>
                        {submitted ? (
                            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-[var(--ns-success)] font-medium">
                                <Check size={10} /> Ready
                            </span>
                        ) : (
                            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-[var(--ns-text3)]">
                                <Clock size={10} /> Waiting
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
